import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  List,
  InputItem,
  Modal,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../../util/axios";
const JixiaoList = styled.div`
  .body {
    height: 100%;
  }
  .month {
    backgroundcolor: #fff;
    padding: 10px 20px 10px 20px;
  }
  .month p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }
  .am-list-item .am-input-label.am-input-label-5 {
    width: 200px;
  }
  .pdd {
    padding: 0px 20px 0px 20px;
  }
  .pdd2 {
    padding: 0px 20px 0px 20px;
    margin-top: 130px;
  }
  .red {
    color: red;
  }
`;
interface scoreArray {
  name: string;
  minScore: string;
  maxScore: string;
}
export default function KhStaff() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [starttimeList, setStarttimeList] = useState<{
    time: number;
  }>({ time: 1 });
  const [endtimeList, setEndtimeList] = useState<{
    time: number;
    status: string;
  }>({ time: 1, status: "" });
  const [text1, setText1] = useState<string>("");
  const [text3, setText3] = useState<string>("");
  const [detailsList, setDetailsList] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [informationList, setInformationList] = useState<{
    uuid: string;
  }>({
    uuid: "",
  });
  const [standardList, setStandardList] = useState<scoreArray[]>([]);
  // 评分标准
  useEffect(() => {
    instance
      .get(
        `/oa/examSetting/standardSetting/getScoreRangeStandardList?timeType=` +
          "month"
      )
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.Data.data)
        if (resp.data.Status === "1") {
          setStandardList(resp.data.Data);
          // console.log(staffList)
        }
      });
  }, []);
  useEffect(() => {
    // 获取现在时间
    const nowTime1 = new Date();
    // console.log(nowTime1)
    console.log(nowTime1.getTime());
    const nowTime = nowTime1.getTime();
    setStarttimeList({
      ...starttimeList,
      time: nowTime,
    });
    let url = decodeURI(window.location.href); //获取请求进来的完整url
    // console.log(url)
    let tstr = url.substring(url.indexOf("?") + 1).split("&"); //先截取url的?后面的参数部分，在根据&分割成参数数组
    // console.log(tstr);
    let tstr0 = tstr[0].substring(9);
    let tstr1 = tstr[1];
    setInformationList({
      uuid: tstr1,
    });
    instance
      .post(
        `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffSome&vSheetId=` +
          tstr0
      )
      .then((resp) => {
        // console.log(resp.data.Data.data)
        // console.log(resp)
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffElse&vSheetId=` +
                tstr0
            )
            .then((resp) => {
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                // console.log(arr);
                // console.log(tstr1)
                let data0 = arr.find((item: any) => item.uuid === tstr1);
                // console.log(data0);
                let name = data0.beTestedStaffCode.substring(
                  0,
                  data0.beTestedStaffCode.indexOf("c")
                );
                let department = data0.beTestedStaffDepartmentCode.substring(
                  0,
                  data0.beTestedStaffDepartmentCode.indexOf("c")
                );
                let post = data0.beTestedStaffPositionCode.substring(
                  0,
                  data0.beTestedStaffPositionCode.indexOf("c")
                );
                let monthlyEvaluationCoefficient =
                  data0.monthlyEvaluationCoefficient;
                let type = data0.type;
                let businessAmount = data0.businessAmount;
                let workPerformance = data0.workPerformance;
                let publicAffair = data0.publicAffair;
                setText1(workPerformance);
                setText3(publicAffair);
                setDetailsList({
                  name: name,
                  department: department,
                  post: post,
                  monthlyEvaluationCoefficient: monthlyEvaluationCoefficient,
                  type: type,
                  businessAmount: businessAmount,
                  // workPerformance: workPerformance,
                  // publicAffair: publicAffair,
                });
              }
            });
        }
      });
    instance
      .get(
        `/oa/examYear/getYearNoticeExecuteStaffList?permissionType=` + "staffMe"
      )
      .then((resp) => {
        console.log(resp);
        // console.log(resp.data.Data.data)
        // // 获取结束时间
        if (resp.data.Status === "1") {
          let data1 = resp.data.Data.data.find(
            (item: any) => item.vSheetId === tstr0
          );
          // console.log(data1);
          const khTime = new Date(data1.考核结束时间).getTime();
          console.log(khTime);
          const Status = data1.status;
          setEndtimeList({
            ...endtimeList,
            time: khTime,
            status: Status,
          });
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(
                  //     `/hr/jxassessment/yearassessment/staff`
                  // );
                  history.go(-1);
                }}
              />
            }
          >
            考核
          </NavBar>
          <WhiteSpace />
          <div className="month">
            {
              <>
                <p>
                  <span>被考核人</span>
                  <span>{detailsList.name ? detailsList.name : "-"}</span>
                </p>
                <p>
                  <span>部门</span>
                  <span>{detailsList.department}</span>
                </p>
                <p>
                  <span>岗位</span>
                  <span>{detailsList.post}</span>
                </p>
                <p>
                  <span>工作报告</span>
                  <span>工作报告名</span>
                </p>
              </>
            }
          </div>
          {/* 考核部长、副部长（部门管理人员）     其他岗*/}
          {/* 公证员岗 翻译岗 制证岗 专家 实习 初任*/}
          {detailsList.type !== "其他" ? (
            <List>
              <InputItem
                type="number"
                placeholder=""
                // onVirtualKeyboardConfirm={v => console.log('虚拟键盘点击确认时的回调函数:', v)}
                editable={false}
                value={detailsList.businessAmount}
                className="pdd"
              >
                <span className="red">*</span>业务量评价
              </InputItem>
              <InputItem
                type="number"
                placeholder="必填"
                value={text1}
                clear
                onChange={(value) => {
                  // const count = parseInt(value);
                  console.log(value);
                  setText1(value);
                }}
                className="pdd"
              >
                <span className="red">*</span>工作成效评价
              </InputItem>
            </List>
          ) : (
            <List>
              <InputItem
                type="number"
                placeholder=""
                editable={false}
                value={detailsList.monthlyEvaluationCoefficient}
                className="pdd"
              >
                <span className="red">*</span>月度工作评价得分均值
              </InputItem>
            </List>
          )}

          {/* 所有岗位都有：个人公共事务参与度评价 */}
          <List>
            <InputItem
              type="number"
              placeholder="必填"
              // onVirtualKeyboardConfirm={v => console.log('虚拟键盘点击确认时的回调函数:', v)}
              value={text3}
              clear
              onChange={(value) => {
                // const count = parseInt(value);
                console.log(value);
                setText3(value);
              }}
              className="pdd"
            >
              <span className="red">*</span>个人公共事务参与度评价
            </InputItem>
          </List>
          <p className="pdd">
            <span
              style={{ color: "#108ee9" }}
              onClick={() =>
                setTankuang({
                  visible: true,
                })
              }
            >
              查看评价标准
            </span>
          </p>
          {detailsList.type !== "其他" ? (
            starttimeList.time > endtimeList.time ||
            endtimeList.status == "未全部打分已提报" ||
            endtimeList.status == "已全部打分已提报" ? (
              <div className="pdd2">
                <Button
                  type="primary"
                  onClick={() => {
                    Toast.info("考核已上报或者考核时间已过", 2);
                  }}
                >
                  提交
                </Button>
                <WhiteSpace />
              </div>
            ) : (
              <div className="pdd2">
                <Button
                  type="primary"
                  onClick={() => {
                    if (text1 == "" || text3 == "") {
                      Toast.info("请填写必填项");
                    } else {
                      instance
                        .post(
                          `/oa/examYear/saveExamYearStaffMarkScore?uuid=` +
                            informationList.uuid +
                            "&workPerformance=" +
                            text1 +
                            "&publicAffair=" +
                            text3
                        )
                        .then((resp) => {
                          // console.log(resp)
                          if (resp.data.Status === "1") {
                            Toast.info(resp.data.Data);
                            setTimeout(function () {
                              history.go(-1);
                            }, 1500);
                          } else {
                            Toast.info(resp.data.Message);
                          }
                        });
                    }
                  }}
                >
                  提交
                </Button>
                <WhiteSpace />
              </div>
            )
          ) : starttimeList.time > endtimeList.time ||
            endtimeList.status == "未全部打分已提报" ||
            endtimeList.status == "已全部打分已提报" ? (
            <div className="pdd2">
              <Button
                type="primary"
                onClick={() => {
                  Toast.info("考核已上报或者考核时间已过", 2);
                }}
              >
                提交
              </Button>
              <WhiteSpace />
            </div>
          ) : (
            <div className="pdd2">
              <Button
                type="primary"
                onClick={() => {
                  if (text3 == "") {
                    Toast.info("请填写必填项");
                  } else {
                    instance
                      .post(
                        `/oa/examYear/saveExamYearStaffMarkScore?uuid=` +
                          informationList.uuid +
                          "&publicAffair=" +
                          text3
                      )
                      .then((resp) => {
                        console.log(resp);
                        if (resp.data.Status === "1") {
                          Toast.info(resp.data.Data);
                          setTimeout(function () {
                            history.go(-1);
                          }, 1500);
                        } else {
                          Toast.info(resp.data.Message);
                        }
                      });
                  }
                }}
              >
                提交
              </Button>
              <WhiteSpace />
            </div>
          )}
          {/* 评分弹框 */}
          <Modal
            visible={tankuang.visible}
            transparent
            maskClosable={false}
            onClose={() =>
              setTankuang({
                visible: false,
              })
            }
            title="评价标准"
            footer={[
              {
                text: "关闭",
                onPress: () => {
                  setTankuang({
                    visible: false,
                  });
                },
              },
            ]}
          >
            <div style={{ height: 200, overflow: "scroll" }}>
              {standardList.map((item) => (
                <>
                  <p>
                    {item.name}[{item.minScore},{item.maxScore})
                  </p>
                </>
              ))}
              {/* <p>标杆作用</p>
                            <p>脱颖而出</p>
                            <p>表现出色</p>
                            <p>平均水平</p>
                            <p>尚需优化</p>
                            <p>及格</p>
                            <p>较差</p>
                            <p>极差</p>
                            <p>不及格</p> */}
            </div>
          </Modal>
        </div>
      </JixiaoList>
    </>
  );
}
